<template>
  <ks-flex
      justify="center"
      v-if="isActive"
  >
    <div
        v-for="(column, idxColumn) in list"
        :class="[{'list-column-active': idxColumn === selectedListItemIndex }]"
        :style="`width: ${columnSize}`"
        :key="'col' + idxColumn"
        @mouseover="setHoverState(column, true)"
        @mouseleave="setHoverState(column, false)"
    >
      <slot
          :column="column"
          :index="idxColumn"
          :activeViewType="activeViewType"
      />
    </div>
  </ks-flex>
</template>

<script>
import checkPermissions from '../../../mixins/checkPermissions';
import Vue from 'vue';

export default {
  name: "ks-data-list-grid",
  props: {
    columnSize: {
      type: String,
      default: '400px'
    }
  },
  mixins: [checkPermissions],
  computed: {
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    list() {
      return this.$parent.list;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    selectedListItemIndex() {
      return this.$parent.data_provider_ref.l_selectedListItemIndex;
    },
    activeViewType() {
      return this.$parent.activeViewType;
    },
    isActive() {
      return this.$parent.activeViewType == 'grid';
    }
  },
  methods: {
    setHoverState(row, value) {
      Vue.set(row, '__hovered', value);
    },
    columnSelected(idxColumn = null) {
      this.data_provider_ref.setSelectedListItemIndex(idxColumn, this.data_provider_ref.enableReadRecordOnListIndexChange);
      this.$emit('onColumnClick', this.list[idxColumn]);
    }
  },
  data() {
    return {}
  }
}
</script>
